import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ palette, shadows, spacing }) => ({
    paper: {
        backgroundColor: palette.background.paper,
        borderRadius: 6,
        boxShadow: shadows[3],
        maxWidth: 425,
    },
    socialButton: {
        marginRight: spacing(2),
    },
    warningIcon: {
        fill: palette.secondary.main,
    },
}));
//# sourceMappingURL=ui_page_failure.css.js.map